import { render, staticRenderFns } from "./brandManage.vue?vue&type=template&id=7117c068&scoped=true"
import script from "./brandManage.vue?vue&type=script&lang=js"
export * from "./brandManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7117c068",
  null
  
)

export default component.exports